import { ZDate } from "./ZDate.js";
import { z } from "zod";
import { ConsumptionData, MrvEventConsumption, MrvEventType } from "./MrvEventConsumption.js";
//
//
// MRV events
//
export const GetMrvEventsArgs = z.object({
    plantId: z.number(),
    timestampGte: ZDate,
    timestampLt: ZDate,
});
export const MrvEvent2 = z.object({
    start: ZDate,
    end: z.nullable(ZDate),
    fromLocationCode: z.string(),
    toLocationCode: z.nullable(z.string()),
    distance_nm: z.number(),
    consumption_tonnes: z.number(),
    previousEnd: z.nullable(ZDate),
});
//
//
// MRV sub-events
//
export const GetMrvSubEventsArgs = z.object({
    plantId: z.number(),
    timestampGte: ZDate,
    timestampLt: ZDate,
});
export const MrvSubEvent = z.object({
    id: z.number(),
    type: z.nativeEnum(MrvEventType),
    timestamp: ZDate,
    latitude_dd: z.number(),
    longitude_dd: z.number(),
    weight_tonnes: z.nullable(z.number()),
    volume_m3: z.nullable(z.number()),
    consumption: z.nullable(MrvEventConsumption),
    remainingOnBoard: z.nullable(ConsumptionData),
    location: z.nullable(z.string()),
    distance_nm: z.number(),
    autoModifyAllowed: z.boolean(),
});
export const MrvSubEventNewProperties = MrvSubEvent.omit({
    id: true,
    latitude_dd: true,
    longitude_dd: true,
    location: true,
    distance_nm: true,
}).deepPartial();
export const EditMrvSubEventPropertyArgs = z.object({
    eventId: z.number(),
    newProperties: MrvSubEventNewProperties,
    deletePaths: z.array(z.array(z.string())),
});
export const EditMrvSubEventResponse = z.object({
    newPosition: z.nullable(z.object({
        latitude_dd: z.number(),
        longitude_dd: z.number(),
        location: z.nullable(z.string()),
        distance_nm: z.number(),
        affectedEvents: z.array(z.object({
            eventId: z.number(),
            newDistance_nm: z.number(),
        })),
    })),
});
export const AddSubEventArgs = z.object({
    plantId: z.number(),
    newProperties: MrvSubEventNewProperties,
});
export const AddSubEventResponse = z.object({
    idOfNewEvent: z.number(),
    latitude_dd: z.number(),
    longitude_dd: z.number(),
    location: z.nullable(z.string()),
    distance_nm: z.number(),
    affectedEvents: z.array(z.object({
        eventId: z.number(),
        newDistance_nm: z.number(),
    })),
});
export const DeleteMrvSubEventArgs = z.object({ id: z.number() });
//# sourceMappingURL=mrv2.js.map